// For enums that are not scoped/localised to certain areas of the app
export enum UrlSearchParams {
  Autoplay = "autoplay",
  Tab = "tab",
  Filter = "filter",
  Search = "search",
  ContentType = "contentType",
  ContentId = "contentId",
  ContentTypeSnakeCase = "content_type",
  ContentIdSnakeCase = "content_id",
  SessionTypeSnakeCase = "session_type",
  SessionIdSnakeCase = "session_id",
  ResourceId = "resourceId",
  ResourceType = "resourceType",
  Domain = "domain",
  Theme = "theme",
}

export enum DiscoverTabs {
  SESSIONS = "sessions",
  LIVE_SCHEDULE = "live-schedule",
  QUICK_READS = "quick-reads",
}

export enum ContentTypes {
  RECORDING = "recording",
  LIVE_SESSION = "live-session",
  ARTICLE = "article",
  SESSION = "session",
}

export enum Services {
  ALL = "All",
  MIND = "Mind",
  MOVEMENT = "Movement",
  NUTRITION = "Nutrition",
  SCIENCE = "Science",
}

export enum RenderMode {
  CARDS = "cards",
  SESSION_TILES = "session-tiles",
}
